/**
 * Converts a camelCase string to title case.
 * @param input - The camelCase string to convert.
 * @returns The converted title case string.
 */
export default function camelCaseToTitleCase(input: string): string {
    const result = input.replace(/([A-Z])/g, " $1"); // Add space before capital letters
    return result.charAt(0).toUpperCase() + result.slice(1); // Capitalize the first letter
}
